import { render } from "./CategoryTiles.vue?vue&type=template&id=859e5efc&scoped=true"
import script from "./CategoryTiles.vue?vue&type=script&lang=js"
export * from "./CategoryTiles.vue?vue&type=script&lang=js"

import "./CategoryTiles.vue?vue&type=style&index=0&id=859e5efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859e5efc"]])

export default __exports__